/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/components/dialogs/manage-business-profile-members-dialog/manage-business-profile-members-dialog.component.scss */
.filter-input {
  padding: 10px 20px 0 16px;
}
/*# sourceMappingURL=manage-business-profile-members-dialog.component.css.map */
